/**
 * longmouth-esc-key.js
 * Escape key shortcut — closes lightbox first if open, then returns home.
 * Priority: lightbox > shop (home)
 */

document.addEventListener("keydown", function (event) {
  if (event.key !== "Escape") return;

  // If a product image lightbox is open, close it and stop here.
  const openLightbox = document.querySelector("[data-product-lightbox].show");
  if (openLightbox) {
    const closeBtn = openLightbox.querySelector("[data-lightbox-close]");
    if (closeBtn) closeBtn.click();
    event.preventDefault();
    return;
  }

  // Otherwise go home.
  const homeButton = document.getElementById("home__button");
  if (homeButton) {
    homeButton.click();
  }
});
